import React from 'react'
import { gql, graphql } from 'react-apollo'
import { withRouter } from 'react-router'
import MaleSweeps from '../templates/MaleSweeps'
import FemaleSweeps from '../templates/FemaleSweeps'
import FriendsThink from '../templates/FriendsThink'
import RateLookFemale from '../templates/RateLookFemale'
import CardStackHOC from '../components/CardStackHOC'
import getSession from '../session'
import cookies from 'browser-cookies'
const sessionId = getSession()

class SweepsCardHOC extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      inputValue: '',
      swipeStyle: { transform: 'rotateZ(0deg) translate3d(0, 0, 0)'},
      errors: []
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.skipLinkHandler = this.skipLinkHandler.bind(this)
  }

  handleChange = (event) => {
    this.setState({inputValue: event.target.value})
  }



  handleSubmit = (event) => {
    const self = this

    event.preventDefault();
    const email = this.state.inputValue
    const emailCheck = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/
    /*** this allows format like hello@gmail (no .tld) which is technically correct but 99.999% unused IRL ***/
    //const w3cEmailCheck = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
    const errors = []

    if(!email){
      errors.push({error: 'email required'})  
    }else{
      if(!emailCheck.test(email)){
      errors.push({error: 'email invalid'})
      }
    }

    if(errors.length === 0){

      const emailEntry = this.state.inputValue

      let submitEntry = new Promise((resolve, reject) => {
        self.props.mutate({variables: {email, sessionId}})
        .then(() => {
          resolve()
        })

      })

      submitEntry.then(() => {
      console.log(`submitted entry - email: ${email}, sessionId: ${sessionId}`)
      cookies.set('finerysweeps', 'true', {expires: 365})
      this.skipLinkHandler()
      })

    }else{
      this.setState({errors: errors})
      console.log('errors:', errors)

    }

  }

  skipLinkHandler = (event) => {
    const path = `/welcome/${this.props.match.params.gender}`
    //console.log('this', this)

    this.setState({swipeStyle: { transition: 'transform 400ms, opacity 100ms 200ms', opacity: '0', transform: 'rotateZ(-10deg) translate3d(-100%, 0, 0)'}})

    setTimeout(()=>{ 
      this.props.history.push(path)
      }, 400);


  }


  render() {

      if(this.props.match.params.gender === 'm'){
        return (
          <CardStackHOC buttonText={`skip`} buttonClickHandler={this.skipLinkHandler} visibleClass={`sweepsCard`}>
            <FriendsThink gender={this.props.match.params.gender} />
            <MaleSweeps swipeStyle={this.state.swipeStyle} handleSubmit={this.handleSubmit} inputValue={this.state.inputValue} handleChange={this.handleChange} errors={this.state.errors} />
          </CardStackHOC>
        )
      }else{
        return (
          <CardStackHOC buttonText={`skip`} buttonClickHandler={this.skipLinkHandler} visibleClass={`sweepsCard`}>
            <RateLookFemale />
            <FemaleSweeps swipeStyle={this.state.swipeStyle} />
          </CardStackHOC>
        )
      }
    }

}

const createSweepsEntryMutation = gql`
mutation createSweepsEntry($email: String!, $sessionId: String!) {
  createSweepsEntry(email: $email, sessionId: $sessionId) {
    sessionId
    email
  }
}
`

const SweepsCardHOCWithMutation = graphql(createSweepsEntryMutation)(withRouter(SweepsCardHOC))

export default SweepsCardHOCWithMutation



// WEBPACK FOOTER //
// ./src/components/SweepsCardHOC.js